module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Click on the map to choose a location.":"Klicken Sie auf die Karte, um einen Ort auszuwählen.","Point on map":"Punkt auf der Karte"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/routing/DestinationSelector.vue
// module id = lUVx
// module chunks = 1